import React from 'react';

import Routes from './routes';

import 'leaflet/dist/leaflet.css';
import './styles/global.css';

function App() {
  return <Routes />;
}

export default App;
